import { Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './components/Header/Header';
import Home from './pages/Home/Home';
import Footer from './components/Footer/Footer';
import { footer } from './components/Data';

function App() {
  return (
    <> 
      <Header/>
      <Home />
      <Footer {...footer} />
       {/* <Routes>
        <Route path="/" element={<Home />} />   
       </Routes> */}
    </>
  );
}

export default App;
